import { AxiosResponse } from "axios";
import { ProcurementHistoricalDetailsRequest, ProcurementHistoricalRequest } from "@/main/models/request";
import { Result } from "@/main/models/common/resultResponse";
import { ProcurementHistoricalDetailsResponse, ProcurementHistoricalResponse } from "@/main/models/response";
import { PaginationResponse } from "@/main/models/common/paginationResponse";

export abstract class IProcurementHistoricalApi {
	abstract getHeader(
		request: ProcurementHistoricalRequest,
	): Promise<AxiosResponse<PaginationResponse<ProcurementHistoricalResponse>>>;
	abstract getDetails(
		request: ProcurementHistoricalDetailsRequest,
	): Promise<AxiosResponse<Result<ProcurementHistoricalDetailsResponse[]>>>;
}
